module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTY2NjMgMTEuMzMzMkg0LjE2NjYzVjkuNjY2NUg5LjE2NjYzVjQuNjY2NUgxMC44MzMzVjkuNjY2NUgxNS44MzMzVjExLjMzMzJIMTAuODMzM1YxNi4zMzMySDkuMTY2NjNWMTEuMzMzMloiIGZpbGw9IiMxQTFBMUEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/icon--add.svg
// module id = 13681
// module chunks = 0